/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProductSummaryResponse
 */
export interface ProductSummaryResponse {
    /**
     * 
     * @type {string}
     * @memberof ProductSummaryResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ProductSummaryResponse
     */
    number: string;
    /**
     * 
     * @type {string}
     * @memberof ProductSummaryResponse
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ProductSummaryResponse
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof ProductSummaryResponse
     */
    imageUrl: string;
    /**
     * 
     * @type {string}
     * @memberof ProductSummaryResponse
     */
    thumbnailUrl: string;
    /**
     * 
     * @type {string}
     * @memberof ProductSummaryResponse
     */
    gtin: string;
    /**
     * 
     * @type {string}
     * @memberof ProductSummaryResponse
     */
    tariffNumber: string;
    /**
     * 
     * @type {number}
     * @memberof ProductSummaryResponse
     */
    weight: number;
    /**
     * 
     * @type {string}
     * @memberof ProductSummaryResponse
     */
    dimensions: string;
    /**
     * 
     * @type {number}
     * @memberof ProductSummaryResponse
     */
    packagingUnit: number;
    /**
     * 
     * @type {ProductSummaryResponsePackagingTypeEnum}
     * @memberof ProductSummaryResponse
     */
    packagingType: ProductSummaryResponsePackagingTypeEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProductSummaryResponse
     */
    productManufacturers: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProductSummaryResponse
     */
    productThemes: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProductSummaryResponse
     */
    productTypes: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof ProductSummaryResponse
     */
    isUnlisted: boolean;
    /**
     * 
     * @type {Date}
     * @memberof ProductSummaryResponse
     */
    unlistedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof ProductSummaryResponse
     */
    imageDownloadUrl?: string;
}


/**
 * @export
 */
export const ProductSummaryResponsePackagingTypeEnum = {
    WithoutPackaging: 'WITHOUT_PACKAGING',
    PolybagFoil: 'POLYBAG_FOIL',
    Cardboard: 'CARDBOARD',
    CardboardPolystyrene: 'CARDBOARD_POLYSTYRENE',
    WindowBox: 'WINDOW_BOX',
    BlisterCard: 'BLISTER_CARD',
    FullBlister: 'FULL_BLISTER',
    Can: 'CAN',
    PrintedProducts: 'PRINTED_PRODUCTS',
    TradingCards: 'TRADING_CARDS',
    Unknown: 'UNKNOWN'
} as const;
export type ProductSummaryResponsePackagingTypeEnum = typeof ProductSummaryResponsePackagingTypeEnum[keyof typeof ProductSummaryResponsePackagingTypeEnum];


/**
 * Check if a given object implements the ProductSummaryResponse interface.
 */
export function instanceOfProductSummaryResponse(value: object): value is ProductSummaryResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('number' in value) || value['number'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('imageUrl' in value) || value['imageUrl'] === undefined) return false;
    if (!('thumbnailUrl' in value) || value['thumbnailUrl'] === undefined) return false;
    if (!('gtin' in value) || value['gtin'] === undefined) return false;
    if (!('tariffNumber' in value) || value['tariffNumber'] === undefined) return false;
    if (!('weight' in value) || value['weight'] === undefined) return false;
    if (!('dimensions' in value) || value['dimensions'] === undefined) return false;
    if (!('packagingUnit' in value) || value['packagingUnit'] === undefined) return false;
    if (!('packagingType' in value) || value['packagingType'] === undefined) return false;
    if (!('productManufacturers' in value) || value['productManufacturers'] === undefined) return false;
    if (!('productThemes' in value) || value['productThemes'] === undefined) return false;
    if (!('productTypes' in value) || value['productTypes'] === undefined) return false;
    if (!('isUnlisted' in value) || value['isUnlisted'] === undefined) return false;
    return true;
}

export function ProductSummaryResponseFromJSON(json: any): ProductSummaryResponse {
    return ProductSummaryResponseFromJSONTyped(json, false);
}

export function ProductSummaryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductSummaryResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'number': json['number'],
        'name': json['name'],
        'description': json['description'],
        'imageUrl': json['imageUrl'],
        'thumbnailUrl': json['thumbnailUrl'],
        'gtin': json['gtin'],
        'tariffNumber': json['tariffNumber'],
        'weight': json['weight'],
        'dimensions': json['dimensions'],
        'packagingUnit': json['packagingUnit'],
        'packagingType': json['packagingType'],
        'productManufacturers': json['productManufacturers'],
        'productThemes': json['productThemes'],
        'productTypes': json['productTypes'],
        'isUnlisted': json['isUnlisted'],
        'unlistedAt': json['unlistedAt'] == null ? undefined : (new Date(json['unlistedAt'])),
        'imageDownloadUrl': json['imageDownloadUrl'] == null ? undefined : json['imageDownloadUrl'],
    };
}

export function ProductSummaryResponseToJSON(json: any): ProductSummaryResponse {
    return ProductSummaryResponseToJSONTyped(json, false);
}

export function ProductSummaryResponseToJSONTyped(value?: ProductSummaryResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'number': value['number'],
        'name': value['name'],
        'description': value['description'],
        'imageUrl': value['imageUrl'],
        'thumbnailUrl': value['thumbnailUrl'],
        'gtin': value['gtin'],
        'tariffNumber': value['tariffNumber'],
        'weight': value['weight'],
        'dimensions': value['dimensions'],
        'packagingUnit': value['packagingUnit'],
        'packagingType': value['packagingType'],
        'productManufacturers': value['productManufacturers'],
        'productThemes': value['productThemes'],
        'productTypes': value['productTypes'],
        'isUnlisted': value['isUnlisted'],
        'unlistedAt': value['unlistedAt'] == null ? value['unlistedAt'] : value['unlistedAt'].toISOString(),
        'imageDownloadUrl': value['imageDownloadUrl'],
    };
}

